<template>
  <div class="card">
    <h3>Finansal Veriler</h3>
    <div class="charts-grid">
      <div class="chart-card">
        <h3>Özkaynaklar</h3>
        <Bar
          v-if="chartOzkaynaklar"
          :data="chartOzkaynaklar"
          :options="{
            ...chartOptions,
            maintainAspectRatio: false,
            responsive: true,
          }"
          :height="250"
        />
      </div>
      <div class="chart-card">
        <h3>Ödenmiş Sermaye</h3>
        <Bar
          v-if="chartOdenmisSermaye"
          :data="chartOdenmisSermaye"
          :options="{
            ...chartOptions,
            maintainAspectRatio: false,
            responsive: true,
          }"
          :height="250"
        />
      </div>
      <div class="chart-card">
        <h3>Satış Gelirleri</h3>
        <Bar
          v-if="chartSatisGelirleri"
          :data="chartSatisGelirleri"
          :options="{
            ...chartOptions,
            maintainAspectRatio: false,
            responsive: true,
          }"
          :height="250"
        />
      </div>
      <div class="chart-card">
        <h3>Brüt Kar</h3>
        <Bar
          v-if="chartBrutKar"
          :data="chartBrutKar"
          :options="{
            ...chartOptions,
            maintainAspectRatio: false,
            responsive: true,
          }"
          :height="250"
        />
      </div>
      <div class="chart-card">
        <h3>Dönem Karı</h3>
        <Bar
          v-if="chartDonemKari"
          :data="chartDonemKari"
          :options="{
            ...chartOptions,
            maintainAspectRatio: false,
            responsive: true,
          }"
          :height="250"
        />
      </div>
      <div class="chart-card">
        <h3>Faaliyet Karı</h3>
        <Bar
          v-if="chartFaaliyetKari"
          :data="chartFaaliyetKari"
          :options="{
            ...chartOptions,
            maintainAspectRatio: false,
            responsive: true,
          }"
          :height="250"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";
import { chartOptions } from "@/charts/barChartHelpers";
import { generateChartOzkaynaklar } from "@/charts/barChartHelpers";
import { generateChartOdenmisSermaye } from "@/charts/barChartHelpers";
import { generateChartSatisGelirleri } from "@/charts/barChartHelpers";
import { generateChartBrutKar } from "@/charts/barChartHelpers";
import { generateChartDonemKari } from "@/charts/barChartHelpers";
import { generateChartFaaliyetKari } from "@/charts/barChartHelpers";

export default {
  components: {
    Bar,
  },
  props: {
    ozetRapor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartOptions,
      chartOzkaynaklar: null,
      chartOdenmisSermaye: null,
      chartSatisGelirleri: null,
      chartBrutKar: null,
      chartDonemKari: null,
      chartFaaliyetKari: null,
    };
  },
  watch: {
    ozetRapor: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.chartOzkaynaklar = generateChartOzkaynaklar(newVal);
          this.chartOdenmisSermaye = generateChartOdenmisSermaye(newVal);
          this.chartSatisGelirleri = generateChartSatisGelirleri(newVal);
          this.chartBrutKar = generateChartBrutKar(newVal);
          this.chartDonemKari = generateChartDonemKari(newVal);
          this.chartFaaliyetKari = generateChartFaaliyetKari(newVal);
        }
      },
    },
  },
};
</script>

<style scoped>
.card {
  background-color: var(--card-bg);
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.card h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(280px, 1fr));
  gap: 1rem;
}

.chart-card {
  padding: 1rem;
  background-color: var(--card-dark);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 300px;
  overflow: visible;
}

.chart-card h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: -0.5rem;
}

@media (max-width: 992px) {
  .charts-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .card {
    padding: 0.75rem;
  }

  .charts-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .chart-card {
    height: 280px;
    padding: 0.75rem 0.5rem;
    margin-bottom: 1.5rem;
  }

  .chart-card h3 {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .card {
    padding: 0.5rem;
    margin-bottom: 1rem;
  }

  .charts-grid {
    gap: 0.5rem;
  }

  .chart-card {
    height: 250px;
    padding: 0.5rem 0.25rem;
    margin-bottom: 2rem;
  }
}
</style>
